import axios from '@/request';
import qs from 'qs';

export default {
  async getWorkOrders(params: any) {
    return axios.get('work-order/list', { params });
  },
  async getComments(params: any) {
    return axios.get('work-order/getcomments', { params });
  },
  async reply(params: any) {
    return axios.post('work-order/attachcomment', qs.stringify(params));
  },
  async getVipExcel(params: any) {
    return axios.get('stadium-vip-excel/list', { params });
  },
  async getVipExcelDetail(params: any) {
    return axios.get('stadium-vip-excel/detail', { params });
  },
  async saveVipExcel(params: any) {
    return axios.post('stadium-vip-excel/edit', qs.stringify(params));
  },
  async importVipExcel(params: any) {
    return axios.post('stadium-vip-excel/import', qs.stringify(params));
  },
  async categorylist(params: any) {
    return axios.get('work-order/category-list', { params });
  },
  async addcategory(params: any) {
    return axios.post('work-order/add-category', qs.stringify(params));
  },
  async editcategory(params: any) {
    return axios.post('work-order/edit-category', qs.stringify(params));
  },
  async categorydetail(params: any) {
    return axios.get('work-order/category-detail', { params });
  },
  async deletecategory(params: any) {
    return axios.post('work-order/delete-category', qs.stringify(params));
  },
  async phraselist(params: any) {
    return axios.get('work-order/phrase-list', { params });
  },
  async addphrase(params: any) {
    return axios.post('work-order/add-phrase', qs.stringify(params));
  },
  async editphrase(params: any) {
    return axios.post('work-order/edit-phrase', qs.stringify(params));
  },
  async phrasedetail(params: any) {
    return axios.get('work-order/phrase-detail', { params });
  },
  async deletephrase(params: any) {
    return axios.post('work-order/delete-phrase', qs.stringify(params));
  },
  async phraseselect(params: any) {
    return axios.get('work-order/phrase-select', { params });
  },
  async chartsdata(params: any) {
    return axios.get('work-order/chartsdata', { params });
  },
  async categoryselect(params: any) {
    return axios.get('work-order/category-select', { params });
  }
};
